import "core-js/modules/es.function.name.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "container-fluild productContainer"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = {
  class: "row productList-row"
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  class: "thumbnail productList-thumbnail"
};
var _hoisted_6 = ["src", "alt"];
var _hoisted_7 = {
  class: "caption"
};

var _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "productListBackground"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_tab_pane = _resolveComponent("el-tab-pane");

  var _component_el_tabs = _resolveComponent("el-tabs");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_tabs, {
    modelValue: $setup.activeName,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $setup.activeName = $event;
    }),
    class: "navList",
    onClick: $setup.changeNav
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.productList, function (item, index) {
        return _openBlock(), _createBlock(_component_el_tab_pane, {
          label: item.title,
          name: item.id,
          key: item.id
        }, {
          default: _withCtx(function () {
            return [_createVNode(_Transition, {
              name: "productList",
              appear: "",
              class: "animate__animated",
              "enter-active-class": "animate__zoomIn"
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.detail, function (product, index) {
                  return _openBlock(), _createElementBlock("div", {
                    class: "col-sm-6 col-md-4",
                    key: product.pid,
                    onClick: function onClick($event) {
                      return $setup.goProductDetail(product);
                    }
                  }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
                    src: product.imgUrl,
                    alt: product.name
                  }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, [_createElementVNode("h3", null, _toDisplayString(product.name), 1), _createElementVNode("p", null, _toDisplayString(product.content), 1)])])], 8, _hoisted_4);
                }), 128))])];
              }),
              _: 2
            }, 1024)];
          }),
          _: 2
        }, 1032, ["label", "name"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue", "onClick"])])]), _hoisted_8], 64);
}